(function () {
    'use strict';

    angular
        .module('observationEditModule', [
            'services.authenticatedUser',
            'aricModule',
            'governanceProcessModule',
            'services.attachments',
            'controlModule',
            'observationModule',
            'recommendationModule'
        ]);
})();
